import { captureException } from '@/utils/asyncSentry'

/**
 * Logs warning with reducer exception
 */
export const logExceptionReducer = (reducer) => (state, action) => {
  try {
    return reducer(state, action)
  } catch (e) {
    // in development log the error in console
    if (process.env.NODE_ENV !== 'production') {
      console.warn(e)
      console.warn(
        'The above error happened during reduce of action =', action,
        '\nStore state =', state
      )
    }
    // report error in sentry
    captureException(e)
    throw e
  }
}

export const exceptionEnhancer = (next) => (reducer, initialState) =>
  next(logExceptionReducer(reducer), initialState)
